import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}


// export const calculateAverage = (array) => {
//   if (!array || array.length === 0) return 0;
//   const sum = array.reduce((acc, val) => acc + (Number(val) || 0), 0);
//   return sum / array.length;
// };

export const getQuadrantLabel = (x, y, xAvg, yAvg) => {
  if (x >= xAvg && y >= yAvg) return 'A';
  if (x < xAvg && y >= yAvg) return 'B';
  if (x < xAvg && y < yAvg) return 'C';
  return 'D';
};

export const dateFormatter = (obj)=>{
    let NSD = null;
    let NED = null;
    if(obj.startDate)
      NSD = new Date(obj.startDate).getFullYear() +'-'+ (new Date(obj.startDate).getMonth()+1).toString().padStart(2, '0') + '-' + new Date(obj.startDate).getDate().toString().padStart(2, '0')
    if(obj.endDate)
      NED = new Date(obj.endDate).getFullYear() +'-'+ (new Date(obj.endDate).getMonth()+1).toString().padStart(2, '0') + '-' + new Date(obj.endDate).getDate().toString().padStart(2, '0')
    return{
        startDate:NSD,
        endDate:NED
    }
}